import HttpClient from "../http/http_client";
export const getAllHomeRequest = async () => {
    try {
        const response = await HttpClient.get('home/');
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}